<template>
  <div class="h-80 d-flex justify-content-center align-items-center">
    <div class="clearfix center-img">
      <b-img
        center
        class="mt-2"
        height="60"
        src="https://dkplayer.s3.sa-east-1.amazonaws.com/logo_Vsl-Booster/LogoVls.png"
        alt="Center image"
      />
    </div>

    <b-card-code
      class="center-card"
    >
      <h5 class="d-flex justify-content-center">
        Configuração ActiveCampaign
      </h5>

      <div>
        <b-row>

          <!-- large -->
          <b-col cols="12 mt-2">
            <validation-observer ref="simpleRules">
              <b-form>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Url"
                    rules="required"
                  >
                    <b-form-input
                      v-model="url"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Url"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>

            </validation-observer>
          </b-col>

          <!-- default -->
          <b-col cols="12 mt-2">
            <validation-observer ref="simpleRules">
              <b-form>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Key"
                    rules="required"
                  >
                    <b-form-input
                      v-model="key"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Key"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
          </b-col>

          <b-col cols="12 mt-2">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              style="margin-right: auto;"
              variant="secondary"
              block
              @click.prevent="validationForm"
            >
              Próxima
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BFormInput, BRow, BCol, BCardText, BFormGroup, BButton, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ActiveCampaignService } from '@/services/ActiveCampaign'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    BFormInput,
    BFormGroup,
    BCardText,
    BRow,
    BCol,
    BButton,
    BForm,
  },
  data() {
    return {
      url: '',
      key: '',
    }
  },
  computed: {
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },

  methods: {
    async validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.ActiveCampaign()
        }
      })
    },
    async ActiveCampaign() {
      const activeCampaignService = new ActiveCampaignService()

      const params = { id_user: this.getUserData.id, active_url: this.url, active_key: this.key }

      await activeCampaignService.CreateActiveCampaign(params)
        .then(() => {
          this.$router.replace({ query: { status: 'closed' } })
        })
    },
  },
}
</script>

<style>
.center-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.center-img {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
